import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { AdminApp } from "./admin/AdminApp.js";
import { PublicForm } from "./public/PublicForm.js";

const isAdmin = window.location.pathname.startsWith("/admin");
if (isAdmin) await import("./styles.css");
else await import("./quiz.css");

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    {isAdmin ? <AdminApp /> : <PublicForm />}
  </StrictMode>
);
